<template>
  <div class="lotbar__wrap" v-if="!loaded">
    <div class="lotbar__day lotbar__day--empty d-none d-sm-inline-block" v-for="n in 3" :key="`empty-lotbar-day-${n}`">
      <div class="lotbar__day__title">
        <span><br></span>
      </div>
      <div class="lotbar__day__content">

        <div v-for="nn in 4" :key="`empty-lotbar-item-${nn}`" class="lotbar-item lotbar-item--empty">

          <div class="lotbar-item__wrap">
          </div>

          <div class="lotbar-item__foot"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="lotbar__wrap" v-else>

    <div v-if="special && special.lottery" class="lotbar__day lotbar__day--special">
      <div class="lotbar__day__content">
        <a :href="`/${special.lottery.slug}`" :class="`lotbar-item lotbar-item--special lotbar-item--${special.lottery.slug} is-customgame is-boloes-game ${special.lottery.slug === lottery ? ' active' : ''}`">
          <div :class="`lotbar-item__wrap lot-${special.lottery.slug}-bg`">
            <div class="lotbar-item__head">
              <div class="lotbar-item__name" :class="special.lottery.name.length > 25 ? '--long' : ''">{{special.lottery.name}}</div>
              <div class="lotbar-item__acron">
                {{special.lottery.acron.slice(0, 2)}}
              </div>

              <div class="lotbar-item__special-name">
                {{specialName}}
              </div>

            </div>

            <div class="lotbar-item__reward">{{special.estimatedPrizeText}}</div>
          </div>

          <div class="lotbar-item__foot"></div>
        </a>
      </div>
    </div>

    <div class="lotbar__day" v-for="day,index in drawsByDay" :key="`lotbar-day-${index}`">
      <div class="lotbar__day__title">
        <strong v-if="day.name ==='Hoje'">{{day.name}}</strong>
        <span v-else>{{day.name}}</span>
      </div>
      <div class="lotbar__day__content" v-if="day.items && day.items.length">
        <a v-for="(item,itemIndex) in day.items"
          :key="`lotbar-item-${itemIndex}`"
          :href="`/${item.slug}`"
          class="lotbar-item"
          :class="[{
            'lotbar-item': true,
            'active': item.slug === lottery,
            'is-customgame' : (item.nextDraw && item.nextDraw.hasCustomGameAvailable),
            'is-boloes-game' : (item.nextDraw && item.nextDraw.hasProductsAvailable)
          }, `lotbar-item--${item.slug}`]"
          >

          <div class="lotbar-item__wrap">
            <div class="lotbar-item__head">
              <div class="lotbar-item__name">{{(item.name.length > 12 && item.shortname) ? item.shortname : item.name}}</div>
              <div class="lotbar-item__acron">{{item.acron}}</div>
              <div class="lotbar-item__day">{{item.nextDraw.drawDateText}}</div>
            </div>
            <div class="lotbar-item__reward">{{(item.nextDraw && item.nextDraw.estimatedPrizeText)}}</div>

            <div v-if="item.nextDraw && item.nextDraw.isJackpot" class="lotbar-item__bullet-jackpot" title="Acumulou!"></div>
          </div>

          <div class="lotbar-item__foot"></div>
        </a>

      </div>
    </div>

  </div>
</template>
<!-- <style src="./Lotbar.scss" scoped /> -->
<script>
import getLotBar from '@services/inventory/getLotBar';

export default {
  name: 'lotbar',
  props: ['lottery'],
  data: function () {
    return {
      special: null,
      draws: null,
      loaded: false
    };
  },
  computed: {
    drawsByDay () {
      const res = [];
      Object.keys(this.draws || []).forEach((key) => {
        if (this.draws[key] && !!this.draws[key].length) {
          res.push({
            name: this.days(key),
            items: this.draws[key]
          })
        }
      });

      return res;
    },
    specialName () {
      return {
        1: 'Virada',
        2: 'Páscoa',
        4: 'São João',
        8: 'Independência'
      }[this.special?.lottery?.id] || '---';
    }
  },
  methods: {
    days (key) {
      return {
        today: 'Hoje',
        tomorrow: 'Amanhã'
      }[key] || 'Próximos';
    },
    scrollToSelected () {
      const selectedLot = document.querySelector('.lotbar-item.active');

      if (selectedLot) {
        const lotbar = document.querySelector('.lotbar');
        lotbar.scroll(selectedLot.offsetLeft - 15, 0);
      }
    },
    fetch () {
      getLotBar()
        .then(res => {
          this.special = res?.special || null;
          this.draws = res?.draws;
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loaded = true;
          setTimeout(() => {
            this.scrollToSelected();
          }, 500)
        })
    }
  },
  created () {
    this.fetch();
  }
}
</script>
